/**
 * Klarna on-site messaging — variant refresh + Figma spacing overrides.
 */
(function () {
  const TEXT_GAP = '6px';

  function styleKlarnaTextWrapper() {
    document.querySelectorAll('.product__klarna-bar klarna-placement').forEach((placement) => {
      const root = placement.shadowRoot;
      if (!root) return;

      root.querySelectorAll('.text-wrapper').forEach((el) => {
        el.style.setProperty('margin-left', TEXT_GAP, 'important');
      });
    });
  }

  function observeKlarnaBar() {
    const bar = document.querySelector('.product__klarna-bar');
    if (!bar) return;

    styleKlarnaTextWrapper();

    const observer = new MutationObserver(() => {
      styleKlarnaTextWrapper();
    });

    observer.observe(bar, { childList: true, subtree: true });

    document.querySelectorAll('.product__klarna-bar klarna-placement').forEach((placement) => {
      if (placement.shadowRoot) {
        observer.observe(placement.shadowRoot, { childList: true, subtree: true });
      }
    });

    let attempts = 0;
    const interval = window.setInterval(() => {
      styleKlarnaTextWrapper();
      attempts += 1;
      if (attempts > 24) window.clearInterval(interval);
    }, 250);
  }

  function refreshKlarnaPlacements(amount) {
    document.querySelectorAll('.product__klarna-bar klarna-placement').forEach((placement) => {
      if (amount != null) {
        placement.setAttribute('data-purchase-amount', amount);
      }
    });

    if (window.KOSMApp?.updatePurchaseAmount && amount != null) {
      window.KOSMApp.updatePurchaseAmount(amount);
    } else if (window.Klarna?.OnsiteMessaging?.refresh) {
      window.Klarna.OnsiteMessaging.refresh();
    } else {
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    }

    window.setTimeout(styleKlarnaTextWrapper, 100);
    window.setTimeout(styleKlarnaTextWrapper, 500);
  }

  function onVariantChange(event) {
    const variant = event?.data?.variant;
    if (!variant?.price) return;

    const bar = document.querySelector('.product__klarna-bar');
    if (!bar) return;

    refreshKlarnaPlacements(variant.price);
  }

  function init() {
    observeKlarnaBar();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
